import { updateLinksAttributes, isLocalUrl } from '../../../utils/handleAttributes';

export default function fairEventsFeed() {
  const widgetName = 'fairEventsFeed';
  const widgetOpts = fairEventsFeedOpts;
  const $widget = $(`#${widgetName}`);
  const $container = $widget;

  return new Promise((resolve) => {
    saffire.widgets.cardWidget($widget, {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,
      link: ['all'],
      itemsPerPanel: 5,
      maxItemsVisible: 5,
      imageIsBackground: true,
      hasImages: true,
      lazyLoadImages: true,
      showDescription: false,
      moreButton: false,
      textOverImage: false,
      buyNowButton: false,

      cardWidgetLoaded(data, _owl, hasData) {
        if (hasData) {
          $container.append('<div class="events-container"></div>');
          createCustomEvents(widgetName, data.items, $container);
          $('.btn-container').appendTo($container);

          resolve(true);
        } else {
          $widget.remove();
          resolve(false);
        }
      },
    });
  });
}

function createCustomEvents(widgetName, items, $container) {
  $(`#${widgetName} .card-widget-item`).each(function (i) {
    const $item = $(this).empty().appendTo($container);
    const $eventContent = $('.events-container');
    const { DateRange, Title, URL } = items[i];

    const dateData = parseEventDate(DateRange);

    $item.append(buildEventInfoLayout(Title));

    if (dateData.hasDate) {
      $item.append(buildEventDateLayout(dateData));
    } else {
      $item.find('.event-info').addClass('no-date');
    }

    setEventLink($item, URL, Title);
    applyAriaLabel($item, Title, URL, dateData);

    $eventContent.append($item);
  });
}

function parseEventDate(widgetDate) {
  if (!widgetDate) {
    return { hasDate: false };
  }

  const parts = widgetDate.split('-').map((p) => p.trim());

  const start = extractDate(parts[0]);
  const end = parts[1] ? extractDate(parts[1]) : null;

  return {
    hasDate: true,
    startMonth: start.month,
    startDay: start.day,
    endMonth: end?.month || null,
    endDay: end?.day || null,
  };
}

function extractDate(str) {
  if (!str) return { month: '', day: '' };

  const clean = str.split(',')[0].trim();
  const [month, day] = clean.split(' ');

  return {
    month: month?.substring(0, 3) || '',
    day: day || '',
  };
}

function setEventLink($item, url, title) {
  if (!url) $item.addClass('void');
  updateLinksAttributes(url, title, $item);
}

function applyAriaLabel($item, title, url, dateData) {
  const dateText = buildAriaDate(dateData);
  const externalText = url && !isLocalUrl(url) ? ' (opens in a new tab)' : '';

  const label = dateText ? `${dateText} - ${title}${externalText}` : `${title}${externalText}`;

  $item.attr('aria-label', label);
}

function buildAriaDate({ hasDate, startMonth, startDay, endMonth, endDay }) {
  if (!hasDate) return '';

  const start = `${convertMonth(startMonth)} ${normalizeDay(startDay)}`;

  if (!endMonth || !endDay) return start;

  if (startMonth === endMonth) {
    return `${start} to ${normalizeDay(endDay)}`;
  }

  return `${start} to ${convertMonth(endMonth)} ${normalizeDay(endDay)}`;
}

function buildEventInfoLayout(title) {
  return `
    <div class="event-info">
      <span class="event-name">${title}</span>
    </div>
  `;
}

function buildEventDateLayout({ startMonth, startDay, endMonth, endDay }) {
  if (!endMonth || !endDay) {
    return `
      <div class="event-date" aria-hidden="true">
        <span class="month">${startMonth}</span>
        <span class="day">${startDay}</span>
      </div>`;
  }

  if (startMonth === endMonth) {
    return `
      <div class="event-date double-date" aria-hidden="true">
        <span class="month">${startMonth}</span>
        <span class="day">
          ${startDay}<span class="divider">-</span>${endDay}
        </span>
      </div>`;
  }

  return `
    <div class="event-date date-range" aria-hidden="true">
      <div class="combo-date">
        <span class="month">${startMonth}</span>
        <span class="day">${startDay}</span>
      </div>

      <span class="divider-month">-</span>

      <div class="combo-date">
        <span class="month">${endMonth}</span>
        <span class="day">${endDay}</span>
      </div>
    </div>`;
}

const monthsFull = {
  Jan: 'January',
  Feb: 'February',
  Mar: 'March',
  Apr: 'April',
  May: 'May',
  Jun: 'June',
  Jul: 'July',
  Aug: 'August',
  Sep: 'September',
  Oct: 'October',
  Nov: 'November',
  Dec: 'December',
};

function convertMonth(month) {
  return monthsFull[month] || month;
}

function normalizeDay(day) {
  return Number.parseInt(day, 10);
}
